import { i18n as I18Next } from 'i18next';
import { injectable } from 'inversify';
import { LogLevelNumbers } from 'loglevel';
import { RootUpdatable, RootProps } from '../types/RootUpdatable';
// @ts-ignore
import { createInstance, LocalizationModule } from '@unitedtraders/i18n';
import { Money } from '@unitedtraders/utcom-api-sdk';
import { FormatRule, moneyFormatter } from '@utex/ui-kit';
import { parse } from 'querystring';
export interface CurrentLang {
  language: string;
}

@injectable()
export class I18Service implements RootUpdatable, CurrentLang {
  public i18next: I18Next;

  constructor(modules: LocalizationModule[], loglevel: LogLevelNumbers, locale: string) {
    this.i18next = createInstance(modules, locale);
    this.i18next.init({
      ns: ['validators'],
      interpolation: {
        escapeValue: false,
        format,
      },
      debug: loglevel === 1,
      lng: locale,
      fallbackLng: 'en',
      fallbackNS: ['validator', 'exception'],
      supportedLngs: ['en', 'ru', 'es'],
      react: {
        wait: true,
        useSuspense: true,
      },
    });
  }

  get language() {
    return this.i18next.language;
  }

  update(attrs: RootProps) {
    this.i18next.changeLanguage(attrs.locale);
  }
}

interface MoneyFormatOptions {
  rule?: FormatRule;
}

function format(value: Money | any, formatWithParams?: string, lng?: string) {
  if (!formatWithParams) {
    return value;
  }

  const [format, params] = formatWithParams.split('?');

  if (format === 'money' && 'value' in value && 'currency' in value) {
    const options = parse(params) as unknown as MoneyFormatOptions;
    return moneyFormatter({ money: value, locale: lng, rule: options.rule || '0-2' }).formatted;
  }
  return value;
}
